module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAElSURBVEhL7dSxSkJRHMfxs/QCgVRTjk1FL6EiTYLvUOQQBA2CCI4lOPQgjS7uDvYSFdTQoOLgln1/Xv9wON7hnsvZ6gcfvF68/9+951x0fzq3aGeH6TPCBj+40YmUseEmaUk4PGmJDV/jYXecrOQYX9DwBk4RFpQuqe8+z1DLDt05XnCNDsKSFgrFlqW//bafA0zhF0ihp+jBvyiv5B7+b0Q3VSha8/DisOQIA2hZooYrE4QF4pdoT7TxOh81XKniA2GBWIk2Xk8aPdxyh7wCsRK9wqVyiFfkDTf2CkflBE+YQ0Nm0D9nuFylluUKS9gQlVSgaE+08Z/o6kRsLvGGIb6hAj1JsozxmB1uS/y7T5IVdOe663c0kTTPWEBPcqET/3HOuV9Su3v1fwzRLgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-paint-brush/dark/24.png
// module id = 2292
// module chunks = 2